import { IToolboxComponentGroup } from '@shesha-io/reactjs';
import PhoneNumberComponent from './components/phoneNumber';

export const allComponents: IToolboxComponentGroup[] = [
  {
    name: 'rsl-crm',
    components: [
      PhoneNumberComponent,
    ],
    visible: true,
  },
];
